import React from 'react';

//
export const MAIN_COLOR = '#00CFC5';

export const ButterflyImage = () => {
  const wingFill = {
    fill: MAIN_COLOR,
    fillOpacity: 1,
  };
  return (
    <g id="g8173" transform="translate(-31.103823,33.766118)">
      <path
        id="Path_73"
        data-name="Path 73"
        d="m 82.48,90.27 c 10,10.42 22.29,17.32 28.54,20.42 a 2.81,2.81 0 0 0 4,-2.52 V 86.29 a 21.44,21.44 0 0 0 -13.81,-20 l -7.6,-2.74 C 73.38,69.62 81.88,89 82.48,90.27 Z"
        fill="#ffffff"
        style={wingFill}
      />
      <path
        id="Path_74"
        data-name="Path 74"
        d="M 109.41,53.05 C 118,51 126.89,47.73 126.89,34.1 V 5.35 a 5.35,5.35 0 0 0 -7.5,-4.89 c -16,7 -52.1,26.18 -52.1,56 0,13.66 6.73,25 15.13,33.78 -18.79,-26.67 14.4,-34.18 26.99,-37.19 z"
        fill="#ffffff"
        style={wingFill}
      />
      <path
        id="Path_75"
        data-name="Path 75"
        d="m 44.41,90.27 c -10,10.42 -22.3,17.32 -28.55,20.42 a 2.81,2.81 0 0 1 -4,-2.52 V 86.29 a 21.45,21.45 0 0 1 13.82,-20 l 7.59,-2.74 C 53.51,69.62 45,89 44.41,90.27 Z"
        fill="#ffffff"
        style={wingFill}
      />
      <path
        id="Path_76"
        data-name="Path 76"
        d="M 17.48,53.05 C 8.86,51 0,47.73 0,34.1 V 5.35 A 5.35,5.35 0 0 1 7.5,0.46 c 16,7 52.1,26.18 52.1,56 0,13.66 -6.73,25 -15.14,33.78 C 63.26,63.57 30.06,56.06 17.48,53.05 Z"
        fill="#ffffff"
        style={wingFill}
      />
    </g>
  );
};
